import instance, { ADMIN_PREFIX } from 'services/api';

// Phase E Cycle 4 canonical (BE catalog.constants).
export enum StoryStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived'
}

export enum StoryType {
  Patient = 'patient',
  Doctor = 'doctor',
  Both = 'both'
}

export interface StoryListRow {
  id: number;
  title: string;
  status: StoryStatus;
  type: StoryType;
  thumbnail: string | null;
  link: string | null;
  img: string | null;
  views: number;
  createdAt: string;
  organization: { id: number; name: string } | null;
}

export interface StoriesListResponse {
  results: StoryListRow[];
  total: number;
}

export interface StoryDetail {
  id: number;
  title: Record<string, string> | null;
  content: Record<string, string> | null;
  type: StoryType | null;
  status: StoryStatus | null;
  link: string | null;
  img: string | null;
  thumbnail: string | null;
  views: number;
  organizationId: number | null;
  [key: string]: unknown;
}

export interface StoryInput {
  title?: Record<string, string>;
  content?: Record<string, string>;
  type?: StoryType;
  status?: StoryStatus;
  link?: string;
  img?: string;
  thumbnail?: string;
  organizationId?: number;
}

export interface FetchStoriesParams {
  page: number;
  limit: number;
  name?: string;
}

export const fetchStories = (params: FetchStoriesParams) =>
  instance.get<StoriesListResponse>(`${ADMIN_PREFIX}/stories/admin`, {
    params
  });

export const fetchStoryById = (id: string | number) =>
  instance.get<StoryDetail>(`${ADMIN_PREFIX}/stories/admin/${id}`);

export const createStory = (input: StoryInput) =>
  instance.post(`${ADMIN_PREFIX}/content/stories`, input);

export const updateStory = (id: string | number, input: StoryInput) =>
  instance.put(`${ADMIN_PREFIX}/content/stories/${id}`, input);

export const deleteStory = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/content/stories/${id}`);
